/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAuth.js.map